/**
 * Implementation extended from:
 * https://www.contentful.com/developers/docs/tutorials/general/getting-started-with-rich-text-field-type/
 * https://github.com/contentful/rich-text/tree/master/packages/rich-text-react-renderer
 */

/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import type { Options } from '@contentful/rich-text-react-renderer';
import type { Document } from '@contentful/rich-text-types';

type OwnProps = {
  content: Document;
  options: Options;
};

type Props = OwnProps & Omit<React.HTMLProps<HTMLDivElement>, keyof OwnProps>;

/**
 * Renders rich text content using Contentful's rich text renderer.
 * @param {Object} props - The properties for the shared articles rich text component.
 * @param {Object} props.content - The rich text document content to be rendered.
 * @param {Object} props.options - The rendering options for the Contentful rich text renderer.
 * @param {Object} [props.divElementProps] - Any additional props to be passed to the containing <div> element.
 * @returns {React.Element} The rendered rich text content.
 */
const SharedArticlesRichText = ({ content, options, ...divElementProps }: Props) => {
  return <div {...divElementProps}>{documentToReactComponents(content, options)}</div>;
};

export default SharedArticlesRichText;
